export const pageTitle = (title) => {
  return (title);
};

